import React, { useState, useRef } from 'react';
import { Modal, Form, Button, Select, DatePicker } from 'antd';
import Moment from 'moment';
import API from '../../../../services/API';

const STATUS_OPTIONS = [
  'CURRENT',
  'CHARGE_OFF',
  'CHARGE_OFF_REVERSED',
  'DELETED',
  'DELETED_CONFIRMED_FRAUD',
  'CLOSED_CONSUMER_REQUESTED',
  'PAID_OR_CLOSED_ZERO_BALANCE',
  'CLOSING'
];

export default function BloomAccountUpdateModal({ furnishingAccount, refresh }) {

  const formRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);

  const labelCol = { span: 12 };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const updateBloomAccount = (data) => {
    console.log('updateBloomAccount', data);
    showModalLoading(true);

    const {
      status,
      closureDate
    } = data;

    const requestData = {
      accountId: furnishingAccount.accountId,
      status,
      closureDate: closureDate ? Moment(closureDate).format('YYYY-MM-DD') : null
    };

    const request = API.patchBloomAccount(requestData);

    request.then((resp) => {
      showModalLoading(false);
      setIsModalOpen(false);
      alert(resp?.message || 'Successfully updated account!');
      if (refresh) refresh();
    }).catch((error) => {
      alert(error?.message || 'Something went wrong');
      showModalLoading(false);
    });
  };

  const cancelPatch = () => {
    setIsModalOpen(false);
  };

  const onFinish = (data) => {
    updateBloomAccount(data);
  };

  const onFinishFailed = (error) => {
    console.log('new error', { ...error });
  };

  return (
    <>
      <Button onClick={showModal} style={{ marginLeft: "auto", border: 'none' }}>
        Update Bloom Account
      </Button>
      <Modal title={"Update Bloom Account"} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            status: furnishingAccount?.accountStatus,
            closureDate: furnishingAccount?.closureDate ? Moment(furnishingAccount.closureDate) : null
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          ref={formRef}
        >
          <div>
            <Form.Item
              label="Status"
              labelCol={labelCol}
              name="status"
              rules={[
                {
                  required: true,
                  message: 'Please select a Status',
                },
              ]}
            >
              <Select
                placeholder="Select status..."
                options={STATUS_OPTIONS.map((option) => ({ label: option, value: option }))}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label="Closure Date"
              labelCol={labelCol}
              name="closureDate"
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={modalLoading}>
                Update!
              </Button>
              &nbsp;
              <Button htmlType="button" onClick={cancelPatch} disabled={modalLoading}>
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
}
